import { useTranslation } from "shared/localization/localization";
import styles from "./Error.module.scss";

export const Error: RFC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.errorWrapper}>
      <div className={styles.errorContent}>
        <div className={styles.icon}>
          <i className="fa-solid fa-shield-exclamation" />
        </div>
        <p>{t("We can't provide this route")}</p>
      </div>
    </div>
  );
};

Error.displayName = "Error";
